import { createAsyncThunk, createEntityAdapter, createSelector, createSlice } from '@reduxjs/toolkit';

import { getResources } from 'FRONTEND/utils/backendApi/resourceApi';

const REDUCER_NAME = 'resource';

const resourceAdapter = createEntityAdapter({
  selectId: (resource) => resource.id,
});

export const listResources = createAsyncThunk(`${REDUCER_NAME}/listResources`, async() => {
  return {
    resourcesList: await getResources(),
  };
});

const initialState = {
  ...resourceAdapter.getInitialState(),
  error: null,
  filterText: '',
};

const resourceSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    clear(state) {
      resourceAdapter.setAll(state, []);
    },
    changeResourceFilterText(state, { payload: filterText }) {
      state.filterText = filterText;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(listResources.fulfilled, (state, { payload: { resourcesList } }) => {
      resourceAdapter.setAll(state, resourcesList);
    });
  },
});

export const {
  selectById: selectResourceById,
  selectAll: selectAllResources,
  selectTotal: selectTotalResources,
} = resourceAdapter.getSelectors((state) => state.resource);


const buildMatchingRegExp = (matchString) => new RegExp(matchString.toLowerCase().split(' ').join('.*'));

export const selectFilteredResources = createSelector(
  selectAllResources,
  (state) => state.resource.filterText,
  (resourcesList, filterText) => {
    const matchingRegExp = buildMatchingRegExp(filterText);

    if (filterText === '') {
      return resourcesList;
    }
    return resourcesList.filter((resource) => resource.alias?.toLowerCase().match(matchingRegExp));
  },
);
export const {
  clear,
  changeResourceFilterText,
} = resourceSlice.actions;

export default resourceSlice.reducer;
